
import { 
    ADD_PAYER_CONFIGURATION,
    ADD_PAYER_CONFIGURATION_SUCCESS,
    ADD_PAYER_CONFIGURATION_FAIL, 
    ADD_PAYER_CONFIGURATION_RESET,
} from "../actions/addPayerConfigurationAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const addPayerConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PAYER_CONFIGURATION:
            return {
                ...state,
                apiState: "loading",
            };
        case ADD_PAYER_CONFIGURATION_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case ADD_PAYER_CONFIGURATION_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case ADD_PAYER_CONFIGURATION_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default addPayerConfigurationReducer;
